import React from 'react'
import Box from '@mui/material/Box'

const VirtuosoListComponent = React.forwardRef<HTMLDivElement, any>(({ style, children }, ref) => (
  <Box
    ref={ref}
    style={{
      ...style,
      display: 'grid',
      gridTemplateColumns: `repeat(auto-fill, minmax(350px, 1fr))`,
      gridGap: '8px',
      overflowX: 'hidden',
    }}
  >
    {children}
  </Box>
))

export default VirtuosoListComponent
